import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-ui-main-layout',
  imports: [CommonModule, RouterModule],
  templateUrl: './ui-main-layout.component.html',
  styleUrl: './ui-main-layout.component.scss',
})
export class UiMainLayoutComponent {}
